const draggable = {}
const methods = [
  'editWidget',
  'editComputed',
  'editCustomCode'
]
const stateModels = {
  editWidget: 'widgetsInEditMode',
  editComputed: 'computedPropsInEditMode',
  editCustomCode: 'customCodeInEditMode'
}

let $ = window.$

for (let method of methods) {
  draggable[method] = function (state, payload) {
    let idx = state[stateModels[method]].indexOf(payload.key)
    setTimeout(() => {
      $('.draggableItem').removeClass('active')
      $('#' + payload.key).addClass('active')
    })
    if (payload.insert) {
      if (~idx) {
        if (payload.line) setCursor(payload.key, payload.line)
        return
      }
      state[stateModels[method]].push(payload.key)
      if (payload.line) {
        setCursor(payload.key, payload.line)
      }
    } else {
      state[stateModels[method]].splice(idx, 1)
    }
  }
}

function setCursor (key, line) {
  setTimeout(() => {
    let editor = $('#' + key).find('.CodeMirror')
    let cm = editor[0].CodeMirror
    cm.setCursor(line - 1)

    let h = cm.getScrollInfo().clientHeight
    let coords = cm.charCoords({line: line, ch: 0}, 'local')
    cm.scrollTo(null, (coords.top + coords.bottom - h) / 2)
  })
}

export default draggable



// WEBPACK FOOTER //
// ./src/store/mutations/draggable.js